
export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Shadowfax Roofing</h3>
            <p className="text-gray-300 mb-4">
              Your trusted partner for professional roofing and solar solutions in California.
            </p>
            <p className="text-sm text-gray-400">Licensed & Insured</p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Roof Installation</li>
              <li>Roof Repair</li>
              <li>Solar Panel Installation</li>
              <li>Roof Inspection</li>
              <li>Emergency Services</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a href="tel:4086280065" className="flex items-center gap-2 text-gray-300 hover:text-blue-400 transition-colors cursor-pointer">
                <i className="ri-phone-line"></i>
                (408) 628-0065
              </a>
              <a href="mailto:info@shadowfaxroofing.com" className="flex items-center gap-2 text-gray-300 hover:text-blue-400 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
                info@shadowfaxroofing.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-gray-400">
          <p>© 2025 Shadowfax Roofing and Solar. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-blue-400 transition-colors cursor-pointer">Powered by Readdy</a></p>
        </div>
      </div>
    </footer>
  );
}
